import React from 'react';
import './ToggleSwitch.css';

/**
 * Generic labelled toggle switch.
 *
 * Props:
 *   label    {string}   – small-caps label shown above the pill (e.g. "Edit mode")
 *   checked  {boolean}  – controlled on/off state
 *   onChange {function} – called with no arguments when the user clicks
 */
export default function ToggleSwitch({label, checked, onChange}) {
  return (
      <div className="toggle-switch-anchor">
        {label && (
            <span className="toggle-switch-label">{label}</span>
        )}
        <button
            type="button"
            className={`toggle-switch${checked ? ' is-on' : ''}`}
            onClick={onChange}
            aria-pressed={checked}
            aria-label={label ? `${label} ${checked ? 'on' : 'off'}`
                : undefined}
        >
          <span className="toggle-switch-thumb"/>
          <span className="toggle-switch-state">
            {checked ? 'ON' : 'OFF'}
          </span>
        </button>
      </div>
  );
}

